import WikiCreationScreen from "@/src/screens/wiki/wiki-creation-screen/wiki-creation-screen";

export default function WikiCreation() {
  return <WikiCreationScreen />;
}
